(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fedco-product-main"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    const thumb = event.target.closest('[data-fedco-product-thumb]');
    if (!thumb) return;
    const gallery = thumb.closest('[data-fedco-product-gallery]');
    const image = gallery.querySelector('.fedco-product__main-image');
    if (!image) return;
    image.src = thumb.dataset.imageSrc;
    image.srcset = '';
    image.alt = thumb.dataset.imageAlt || '';
    gallery.querySelectorAll('[data-fedco-product-thumb]').forEach(function (button) {
      button.classList.toggle('is-active', button === thumb);
    });
  });

  document.addEventListener('change', function (event) {
    const input = event.target.closest('[data-fedco-option-input]');
    if (!input) return;
    const productSection = input.closest('[data-fedco-product-gallery]');
    if (!productSection) return;
    const dataElement = productSection.querySelector('[data-fedco-variants]');
    if (!dataElement) return;

    let variants;
    try {
      variants = JSON.parse(dataElement.textContent);
    } catch (error) {
      return;
    }

    const selectedOptions = Array.from(productSection.querySelectorAll('[data-fedco-option-input]:checked')).map(function (selectedInput) {
      return selectedInput.value;
    });
    const selectedVariant = variants.find(function (variant) {
      return variant.options.length === selectedOptions.length && variant.options.every(function (option, index) {
        return option === selectedOptions[index];
      });
    });
    if (!selectedVariant) return;

    const price = productSection.querySelector('[data-fedco-variant-price]');
    if (price) price.textContent = selectedVariant.price;

    if (selectedVariant.imageSrc) {
      const mainImage = productSection.querySelector('.fedco-product__main-image');
      if (mainImage) {
        mainImage.src = selectedVariant.imageSrc;
        mainImage.srcset = '';
        mainImage.alt = selectedVariant.imageAlt || '';
      }
      productSection.querySelectorAll('[data-fedco-product-thumb]').forEach(function (thumb) {
        thumb.classList.toggle('is-active', thumb.dataset.mediaId === String(selectedVariant.mediaId));
      });
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', selectedVariant.id);
    window.history.replaceState({}, '', url.toString());
    productSection.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: selectedVariant } }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
